var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: { visible: _vm.visible, "append-to-body": "", width: "60%" },
      on: { close: _vm.close },
    },
    [
      _c("div", { staticClass: "title-box" }, [_vm._v("基础数据")]),
      _c(
        "el-form",
        { attrs: { model: _vm.statisticsForm, size: "mini" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "时间筛选" } },
            [
              _c("el-date-picker", {
                attrs: {
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.statisticsDate,
                  callback: function ($$v) {
                    _vm.statisticsDate = $$v
                  },
                  expression: "statisticsDate",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "margin-left-15",
                  attrs: {
                    type: "primary",
                    icon: "el-icon-search",
                    size: "mini",
                    disabled: _vm.loading,
                  },
                  on: { click: _vm.getSearchStatistics },
                },
                [_vm._v("筛选")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    icon: "el-icon-delete",
                    size: "mini",
                    disabled: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.reset("statistics")
                    },
                  },
                },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { margin: "0 10px" },
          attrs: {
            data: _vm.statisticsList,
            border: "",
            size: "mini",
            "max-height": "280px",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "活动PV", align: "center", prop: "viewAllCount" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "活动UV",
              align: "center",
              prop: "viewAllUserCount",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "活动总抽奖次数",
              align: "center",
              prop: "raffleAllCount",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "活动抽奖人数",
              align: "center",
              prop: "raffleAllUserCount",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "title-box margin-top-20" }, [
        _vm._v("用户参与记录"),
      ]),
      _c(
        "el-form",
        { attrs: { model: _vm.recordForm, size: "mini", inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "时间筛选" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.recordDate,
                  callback: function ($$v) {
                    _vm.recordDate = $$v
                  },
                  expression: "recordDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户搜索" } },
            [
              _c("el-input", {
                attrs: { placeholder: "输入用户手机号", clearable: "" },
                model: {
                  value: _vm.recordForm.userPhone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.recordForm,
                      "userPhone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "recordForm.userPhone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                icon: "el-icon-search",
                size: "mini",
                disabled: _vm.loading,
              },
              on: { click: _vm.search },
            },
            [_vm._v("筛选")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "danger",
                icon: "el-icon-delete",
                size: "mini",
                disabled: _vm.loading,
              },
              on: {
                click: function ($event) {
                  return _vm.reset("record")
                },
              },
            },
            [_vm._v("清空")]
          ),
        ],
        1
      ),
      _c(
        "yd-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.recordList,
            border: "",
            size: "mini",
            pagination: _vm.pagination,
          },
          on: { onChange: _vm.onTableChange, onInit: _vm.onInit },
        },
        [
          _c("el-table-column", {
            attrs: { label: "用户ID", prop: "userId", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "用户手机号", prop: "userPhone", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "抽奖时间", prop: "raffleTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "抽奖情况", prop: "prizeName", align: "center" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.exportExcel } },
            [_vm._v("导 出")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }